module.exports = __webpack_public_path__ + "static/media/homeIcon.d670d0dc.svg";